import { render, staticRenderFns } from "./BookingItemPane.vue?vue&type=template&id=9c6154e6&"
import script from "./BookingItemPane.vue?vue&type=script&lang=js&"
export * from "./BookingItemPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports